import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeIcon',
  standalone: true,
  pure: true
})
export class PlaceIconPipe implements PipeTransform {

  transform(type: number): string {
    const mapping: { [key: number]: string } = {
      1: 'anchor',
      2: 'warehouse',
      3: 'diamond',
    };
    // Retorna el icono correspondiente o, si no existe, uno por defecto (por ejemplo, 'y')
    return mapping[type] || 'close';
  }

}
